import { useEffect, useRef, useState } from 'react';
type rawData = { id?: number, first_name: string, last_name: string, avatar: string | null }[]

const EMPTY_CONTACTS: any[] = [];

export const useContacts = (initialData: any = EMPTY_CONTACTS) => {

    const [data, setData] = useState<rawData>(initialData);
    const [sign, setSign] = useState('');
    const initialDataRef = useRef(initialData);
    initialDataRef.current = initialData;
    const initialDataSnapshot = JSON.stringify(initialData);

    const normalizeContactRecord = (record: any) => {
        if (record.avatar && !String(record.avatar).startsWith('http'))
            record.avatar = process.env.REACT_APP_API_URL + '/images/avatar/' + record.avatar
        return record
    };

    useEffect(() => {
        const source = initialDataRef.current;
        if (source.length === 0) {
            setData([]);
        } else {
            setData(source.map((e: any) => normalizeContactRecord(e)));
        }
    }, [initialDataSnapshot]);

    useEffect(() => {
        setSign(JSON.stringify(data));
    }, [data]);


    return {
        sign,
        list: (data ? data : []),
        get: (id: number | string): keyof rawData | boolean => {
            if (!data)
                return false
            const items = data.filter(
                (contact) => Number(contact?.id) === Number(id)
            )
            if (items.length > 0)
                return Object(items[0])
            return false
        },

        delete: (id: number | string): boolean => {
            if (!data)
                return false
            setData(data.filter((contact) => Number(contact.id) !== Number(id)))
            return true
        },
        update: (item: keyof rawData): void => {
            if (!data || (Array.isArray(data) && data.length === 0)) {
                setData([normalizeContactRecord(item)])
            } else {
                let found = false;

                let normalizedRecordData = data.map((elementEntry: any) => {
                    if (elementEntry?.id && Object(item)?.id && Number(elementEntry.id) === Number(Object(item).id)) {
                        found = true
                        return normalizeContactRecord(item)
                    }
                    return elementEntry
                });

                if (!found) normalizedRecordData = [item].concat(normalizedRecordData);
                setData(normalizedRecordData);
            }
        }
    }
}
